import React, { useEffect, useMemo, useState } from 'react'
import TestimonialThumbSVG from '../assets/testimonial-thumb.svg';
import FlexBox from 'schoolUiComponents/basic/Box/FlexBox';
import { FlexProps } from 'schoolUiComponents/basic/Box/FlexBox/types';
import Text from 'schoolUiComponents/basic/Text';
import Box from 'schoolUiComponents/basic/Box';
import { TESTIMONIALS_TEXT } from '../constants';
import { Colors } from 'baseStyles/enums/colors';
import TeacherSignupStyles from '../style';


let testimonialInterval: any = null;
const Testimonials = () => {

    const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState<number>(0);
    const themeStyles = TeacherSignupStyles();

    const currentTestimonial = useMemo(() => {
        return TESTIMONIALS_TEXT[currentTestimonialIndex];
    }, [currentTestimonialIndex]);

    const updateTestimonial = () => {
        setCurrentTestimonialIndex((prevIndex) => {
            if (prevIndex === TESTIMONIALS_TEXT.length - 1) {
                return 0;
            } else {
                return prevIndex + 1;
            }
        });
    };

    useEffect(() => {
        testimonialInterval = setInterval(() => {
            updateTestimonial();
        }, 12000)
        return () => {
            clearInterval(testimonialInterval);
        }
    }, [])

    return (
        <FlexBox column alignStart {...themeStyles.testimonialsBlock}>
            <Box fullWidth className='teacher-signup-title-text'><Text.H2 fullWidth lines={4} fontWeight={700}>Help every student succeed with differentiated learning. 100% free.</Text.H2></Box>

            <FlexBox {...themeStyles.testimonialsContent} margin={`32px 0 0 0`}>
                <Box fullWidth={!themeStyles?.testimonialsContent?.noFullWidth} className='signup-study-icon-box'>
                    <TestimonialThumbSVG />
                </Box>
                <FlexBox className='signup-testimonial-card' {...themeStyles.testimonialContextText}>
                    <Text.H4 fullWidth={!themeStyles?.testimonialsContent?.noFullWidth} lines={8} fontWeight={400} color={Colors.CONTENT_TEXT_SECONDARY}>{currentTestimonial?.[0]}</Text.H4>
                    <Text.H4 fullWidth={!themeStyles?.testimonialsContent?.noFullWidth} lines={3} fontWeight={600} color={Colors.CONTENT_TEXT_SECONDARY}>{currentTestimonial?.[1]}</Text.H4>
                </FlexBox>
            </FlexBox>
        </FlexBox>
    )
}

export default Testimonials